module.exports = __webpack_public_path__ + "static/media/marker10.13d21c5d.png";